import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FindCarworkshopMapsComponent } from "./find-carworkshop-maps/find-carworkshop-maps.component";
import { GoogleMapsModule } from "@angular/google-maps";
import { environment } from "@env";
import { SelectDatePeriodAvailableCarworkshopComponent } from "./select-date-period-available-carworkshop/select-date-period-available-carworkshop.component";
import { TranslateModule } from "@ngx-translate/core";
import { ReactiveFormsModule } from "@angular/forms";
import { AngularMaterialModule } from "@shared/modules/angular-material/angular-material.module";
import { MultipleNetworkAutocompleteComponent } from "./multiple-network-autocomplete/multiple-network-autocomplete.component";
import { CurrencyFormatPipe } from "@shared/pipes";

@NgModule({
  declarations: [
    FindCarworkshopMapsComponent,
    SelectDatePeriodAvailableCarworkshopComponent,
    MultipleNetworkAutocompleteComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    GoogleMapsModule
  ],
  exports: [
    FindCarworkshopMapsComponent,
    SelectDatePeriodAvailableCarworkshopComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [CurrencyFormatPipe]
})
export class FindCarworkshopMapsModule {}
